import { $http } from "@/utils/http";
import { fixBody } from "@/helpers/variables/index";
import {
    CHANGE_POPUP_FAST_BUY,
    CHANGE_PRODUCT_LOADING,
    CHANGE_REVIEWS_LOADING,
    RESET_PRODUCT,
    REVIEWS_CHANGE_PAGE,
    SAVE_PROMMOCODE,
    SET_LOADING_SEND_REVIEW,
    SET_NEW_COLLECTION_LIST,
    SET_NEW_COLLECTION_LIST_LOADING,
    SET_NEW_LIST_LENGTH,
    SET_PRODUCT,
    SET_PROMO_LIST,
    SET_PROMO_LIST_LENGTH,
    SET_PROMO_LOADING,
    SET_REVIEWS,
    SET_REVIEWS_LENGTH,
} from "../mutation-types";

import {
    GET_NEW_COLLECTION_LIST,
    GET_PRODUCT,
    GET_PRODUCT_REVIEWS,
    GET_PROMO_LIST,
    GET_PROMOCODE,
    SEND_REVIEW,
} from "../action-types";

const state = {
    promocodeResponse: "",
    skip: 4,
    product: null,
    productLoading: false,
    promoList: null,
    promoListLength: null,
    promoListLoading: false,
    newCollectionList: null,
    newCollectionListLength: null,
    newCollectionListLoading: false,
    reviewList: null,
    reviewListLength: null,
    reviewListLoading: false,
    sendReviewsLoading: false,
    popupFastBuy: {
        show: false,
        product_id: null,
        count: 1,
    },
    limit: 10,
    page: 1,
};
//
const getters = {
    promocodeResponse: state => state.promocodeResponse,
    skip: state => state.skip,
    product: state => state.product,
    productLoading: state => state.productLoading,
    promoList: state => state.promoList,
    promoListLength: state => state.promoListLength,
    promoListLoading: state => state.promoListLoading,
    newCollectionList: state => state.newCollectionList,
    newCollectionListLength: state => state.newCollectionListLength,
    newCollectionListLoading: stapromocodete => state.newCollectionListLoading,
    reviewList: state => state.reviewList,
    reviewListLength: state => state.reviewListLength,
    reviewListLoading: state => state.reviewListLoading,
    popupFastBuy: state => state.popupFastBuy,
    sendReviewsLoading: state => state.sendReviewsLoading,
    limit: state => state.limit,
    page: state => state.page,
};
//
const actions = {
    [GET_PROMOCODE]: async ({ commit }) => {
        try {
            const response = await $http.get(`v1/promo_codes`);
            commit(SAVE_PROMMOCODE, response.data.data);
        } catch (e) {
            throw e;
        } finally {
        }
    },
    [GET_PRODUCT]: async ({ commit }, payload) => {
        commit(CHANGE_PRODUCT_LOADING, true);
        // commit(RESET_PRODUCT);
        try {
            const response = await $http.get(`v1/product/${payload.slug}`);

            commit(SET_PRODUCT, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_PRODUCT_LOADING, false);
        }
    },
    [GET_PRODUCT_REVIEWS]: async ({ commit }, payload) => {
        commit(CHANGE_REVIEWS_LOADING, true);
        try {
            const response = await $http.get(
                `v1/product-reviews?product_id=${payload.id}&per-page=${state.limit}&page=${state.page}`
            );
            commit(SET_REVIEWS, response.data.data);
            commit(SET_REVIEWS_LENGTH, response.data.meta.total);
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_REVIEWS_LOADING, false);
        }
    },
    [GET_PROMO_LIST]: async ({ commit }, payload) => {
        commit(SET_PROMO_LOADING, true);
        try {
            const response = await $http.get(`v1/products-for-sale/random?except=${payload.id}&per-page=${state.skip}`);
            commit(SET_PROMO_LIST, response.data.data);
            commit(SET_PROMO_LIST_LENGTH, response.data.data.length);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_PROMO_LOADING, false);
        }
    },
    [GET_NEW_COLLECTION_LIST]: async ({ commit }, payload) => {
        commit(SET_NEW_COLLECTION_LIST_LOADING, true);
        try {
            const response = await $http.get(`v1/new-products/random?except=${payload.id}&per-page=${state.skip}`);
            commit(SET_NEW_COLLECTION_LIST, response.data.data);
            commit(SET_NEW_LIST_LENGTH, response.data.data.length);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_NEW_COLLECTION_LIST_LOADING, false);
        }
    },
    [SEND_REVIEW]: async ({ commit }, payload) => {
        try {
            commit(SET_LOADING_SEND_REVIEW, true);
            const result = await $http.post("v1/product-reviews", payload);
            // console.log(result);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_LOADING_SEND_REVIEW, false);
        }
    }, // eslint-disable-next-line
};
//
const mutations = {
    [SET_PRODUCT](state, obj) {
        const filters = {};

        if (obj.simular_products.length) {
            obj.simular_products.forEach(sim_product => {
                sim_product.attributes.forEach(attr => {
                    if (!filters.hasOwnProperty(attr.attribute.slug)) {
                        filters[attr.attribute.slug] = {};
                        filters[attr.attribute.slug].list = [];
                        filters[attr.attribute.slug].title = attr.attribute.title;
                    }
                    attr.slug = sim_product.slug;
                    attr.id = sim_product.id;
                    attr.active = false;
                    filters[attr.attribute.slug].list.push(attr);
                });
            });
            const slugs = obj.options.map(e => e.slug);
            for (let i in filters) {
                if (!slugs.includes(i)) {
                    delete filters[i];
                }
            }

            //comparison all filters with options
            const newFilter = {};
            obj.options.forEach(e => {
                newFilter[e.slug] = [e.slug];
            });
            const selectedAttributes = {};
            obj.attributes.forEach(e => {
                if (slugs.includes(e.attribute.slug)) selectedAttributes[e.attribute.slug] = e;
            });
            for (let i in selectedAttributes) {
                for (let y in newFilter) {
                    if (i === y) {
                        selectedAttributes[i].active = true;
                        newFilter[i].list
                            ? newFilter[i].list.unshift(selectedAttributes[i])
                            : newFilter[i].unshift(selectedAttributes[i]);
                    }
                }
            }
            for (let i in newFilter) {
                if (!selectedAttributes.hasOwnProperty(i)) {
                    delete newFilter[i];
                }
            }
            obj.filters = newFilter;
        }

        state.product = obj;

        state.product.images.unshift({
            link: state.product.image,
        });
    },
    [SAVE_PROMMOCODE](state, data) {
        state.promocodeResponse = data;
    },
    [RESET_PRODUCT](state) {
        state.product = null;
    },
    [SET_REVIEWS](state, obj) {
        state.reviewList = obj;
    },
    [CHANGE_REVIEWS_LOADING](state, status) {
        state.reviewListLoading = status;
    },
    [SET_LOADING_SEND_REVIEW](state, status) {
        state.sendReviewsLoading = status;
    },
    [SET_PROMO_LIST](state, list) {
        state.promoList = list;
    },
    [SET_PROMO_LOADING](state, status) {
        state.promoListLoading = status;
    },
    [CHANGE_PRODUCT_LOADING](state, status) {
        state.productLoading = status;
    },
    [SET_NEW_COLLECTION_LIST](state, list) {
        state.newCollectionList = list;
    },
    [SET_NEW_COLLECTION_LIST_LOADING](state, status) {
        state.newCollectionListLoading = status;
    },
    [SET_PROMO_LIST_LENGTH](state, data) {
        state.promoListLength = data;
    },
    [SET_NEW_LIST_LENGTH](state, data) {
        state.newCollectionListLength = data;
    },
    [SET_REVIEWS_LENGTH](state, data) {
        state.reviewListLength = data;
    },
    [CHANGE_POPUP_FAST_BUY](state, params) {
        state.popupFastBuy = params;
        fixBody(params);
    },
    [REVIEWS_CHANGE_PAGE](state, page) {
        state.page = page;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
